var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MbsLayout',{attrs:{"isNeedHeader":true},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('MbsHeader')]},proxy:true},{key:"sidebar",fn:function(){return [_c('MbsMenu',{attrs:{"menuListData":_vm.menuList}}),_c('div',[_vm._v("12")])]},proxy:true},{key:"content",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }